const KIOSK_CART_FUNNEL_TOP_PADDING_VALUES = new Set([
  'auto',
  'none',
  'small',
  'medium',
  'large',
  'xlarge',
]);

/** Unknown or missing values stay on the legacy spacing. */
export function resolveCartFunnelPadding(value: unknown): string {
  return typeof value === 'string' && KIOSK_CART_FUNNEL_TOP_PADDING_VALUES.has(value)
    ? value
    : 'auto';
}

export function resolveKioskCartFunnelTopPadding(value: unknown): string {
  return resolveCartFunnelPadding(value);
}
